import { Job } from "@core/domains/jobs";
import {
  CursorPaginationSchema,
  adminApi,
  apiEndpoint,
  cursorPaginatedResponse,
} from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { BUS_SERVICE } from "../config/index.ts";

import { NotificationSubscriptionSchema } from "./bus-notification.ts";

export const busAdminApi = adminApi(
  { domain: API_DOMAIN, path: `${BUS_SERVICE.LABEL}/admin` },
  {
    getJobs: apiEndpoint({
      body: z.object(
        {
          ...CursorPaginationSchema.shape,
          principalId: Job.shape.principalId,
          resourceId: Job.shape.resourceId,
          type: Job.shape.type,
        },
        {
          ...CursorPaginationSchema.descriptions,
          principalId: Job.descriptions.principalId,
          resourceId: Job.descriptions.resourceId,
          type: Job.descriptions.type,
        },
      ),
      response: cursorPaginatedResponse(Job.schema),
    }),
    subscribeToNotifications: apiEndpoint({
      response: NotificationSubscriptionSchema,
    }),
  },
);
